<template>
    <v-card flat>
        <v-card-text>
            <v-card-title primary-title>
                <div>
                    <h3 class="headline mb-0">Información Socioeconómica</h3>
                    <span class="grey--text">{{datosSocioeconomicos.fechaActualizacion}}</span>
                </div>
            </v-card-title>
            <v-form v-model="valid" v-if="!cargandoDatos">
                <v-container fluid grid-list-md>
                    <v-subheader class="pl-0 black--text" >Nivel máximo de estudios alcanzado por tus padres aunque hayan falledido</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="nivelEstudios"
                                    v-model="datosSocioeconomicos.padre.nivelEstudios"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="Nivel de Estudios del Padre"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="nivelEstudios"
                                    v-model="datosSocioeconomicos.madre.nivelEstudios"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="Nivel de Estudios de la Madre"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-flex xs12 md12>
                        <v-autocomplete
                                :items="quienVives"
                                v-model="datosSocioeconomicos.quienVives"
                                item-value="id"
                                item-text="descripcion"
                                label="¿Con quién vives actualmente?"
                        ></v-autocomplete>
                    </v-flex>

                    <v-subheader class="pl-0 black--text" >Ingresos Familiares Mensuales</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md2>
                            <v-text-field
                                    v-model="datosSocioeconomicos.ingresos.padre"
                                    label="Padre"
                                    prefix="$"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 md2>
                            <v-text-field
                                    v-model="datosSocioeconomicos.ingresos.madre"
                                    label="Madre"
                                    prefix="$"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 md2>
                            <v-text-field
                                    v-model="datosSocioeconomicos.ingresos.hermanos"
                                    label="Hermanos"
                                    prefix="$"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 md2>
                            <v-text-field
                                    v-model="datosSocioeconomicos.ingresos.propios"
                                    label="Propios"
                                    prefix="$"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 md2>
                            <v-text-field
                                    v-model="datosSocioeconomicos.ingresos.otros"
                                    label="Otros"
                                    prefix="$"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-subheader class="pl-0 black--text">¿Cuál es la ocupación o Trabajo de tus padres o tutores?</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="ocupaciones"
                                    v-model="datosSocioeconomicos.padre.ocupacion"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="Ocupación del Padre"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="ocupaciones"
                                    v-model="datosSocioeconomicos.madre.ocupacion"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="Ocupación de la Madre"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="quienDependes"
                                    v-model="datosSocioeconomicos.quienDependes"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="¿De quién dependes económicamente?"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="casaVives"
                                    v-model="datosSocioeconomicos.casaVives"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="La casa donde vives es:"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="cuartosCasa"
                                    v-model="datosSocioeconomicos.cuartosCasa"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="¿Cuántos cuartos tiene la casa (sin contar baños ni pasillos)?"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="cuartosCasa"
                                    v-model="datosSocioeconomicos.personasCasa"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="¿Cuántas personas viven en la casa?"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="cuartosCasa"
                                    v-model="datosSocioeconomicos.personasDependen"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="¿Cuántas personas incluyéndote a ti, dependen económicamente del principal apoyo o sustento?"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-progress-linear :indeterminate="true" v-else="cargandoDatos"></v-progress-linear>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    flat
                    @click="guardar"
                    :loading="guardarLoading"
                    :disabled="guardarLoading || !valid"
            >Guardar</v-btn>
        </v-card-actions>
        <v-snackbar
                :color="'success'"
                :top="'top'"
                :right="true"
                v-model="snackbar"
        >
            {{ snackbarMensaje }}
            <v-btn flat @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
  import axios from 'axios'
  import * as moment from 'moment'

  export default {
    name: 'DatosSocioeconomicos',
    created () {
      this.loadCatalogos()
      this.loadDatosSocioeconomicos()
    },
    data: () => ({
      valid: false,
      cargandoDatos: false,
      guardarLoading: false,
      snackbar: false,
      snackbarMensaje: '',
      datosSocioeconomicos: {
        padre: { },
        madre: { },
        ingresos: { }
      },
      nivelEstudios: [],
      quienVives: [],
      ocupaciones: [],
      quienDependes: [],
      casaVives: [
        {id: 'P', descripcion: 'Propia'},
        {id: 'R', descripcion: 'Rentada'},
        {id: 'E', descripcion: 'Prestada'},
        {id: 'S', descripcion: 'Se está pagando'},
        {id: 'O', descripcion: 'Otra'}
      ],
      cuartosCasa: []
    }),
    methods: {
      loadCatalogos () {
        axios.get('catalogo/nivel-estudios')
          .then(resp => {
            this.nivelEstudios = resp.data.nivelEstudios
          })
          .catch(err => {
            console.log(err)
          })
        axios.get('catalogo/ocupaciones')
          .then(resp => {
            this.ocupaciones = resp.data.ocupaciones
          })
          .catch(err => {
            console.log(err)
          })
        axios.get('catalogo/quien-vives')
          .then(resp => {
            this.quienVives = resp.data.quienVives
          })
          .catch(err => {
            console.log(err)
          })
        axios.get('catalogo/quien-dependes')
          .then(resp => {
            this.quienDependes = resp.data.quienDependes
          })
          .catch(err => {
            console.log(err)
          })
        axios.get('catalogo/cuartos-casa')
          .then(resp => {
            this.cuartosCasa = resp.data.cuartosCasa
          })
          .catch(err => {
            console.log(err)
          })
      },
      loadDatosSocioeconomicos () {
        this.cargandoDatos = true
        axios.get('alumno/datos-socioeconomicos')
          .then(resp => {
            this.cargandoDatos = false
            moment.locale('es')
            const fechaActualizacion = resp.data.socioEconomicos.fechaActualizacion ? moment(resp.data.socioEconomicos.fechaActualizacion).format('LLLL') : ''

            this.datosSocioeconomicos = resp.data.socioEconomicos
            this.datosSocioeconomicos.fechaActualizacion = fechaActualizacion
          })
          .catch(err => {
            console.log(err)
          })
      },
      guardar () {
        this.guardarLoading = true
        axios.put('alumno/datos-socioeconomicos', this.datosSocioeconomicos)
          .then(resp => {
            this.guardarLoading = false
            console.log(resp)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/DatosSocioeconomicos.vue